var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    {
      staticClass: "no-border",
      attrs: {
        id: "select-mortgage-type-search",
        "no-label": "",
        label: _vm.$t("global.words.search"),
        "hidden-label": true,
      },
    },
    [
      _c("v-select-field", {
        staticClass: "search-input w-100 vsSelectedCheckboxes",
        attrs: {
          options: _vm.mortgageTypeOptions,
          placeholder: _vm.$t("global.actions.chooseOption"),
          label: "text",
          clearable: true,
          "default-value": _vm.localSelectedMortgageType,
          multiple: _vm.multiple,
          action: _vm.action,
          "deselect-from-dropdown": "",
          "has-checkboxes": "",
        },
        on: {
          "option:selected": _vm.handleChange,
          "option:deselected": _vm.handleChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }